"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _lodash = require("lodash");
function findHomeOrFirstAddress(addresses) {
  return (0, _lodash.find)(addresses, {
    address_type: 'home'
  }) || (0, _lodash.first)(addresses) || '';
}
var _default = exports["default"] = findHomeOrFirstAddress;